module.exports = __webpack_public_path__ + "images/centaur9b7baa7aee7009f6a6873397e249982c.png";